import { setCookie } from './simple-cookie.js'

export const cookies = ['functional-cookies', 'analytics-cookies', 'marketing-cookies']
export const requiredCookies = ['functional-cookies', 'analytics-cookies']

var cookieToModeMapping = {
  'analytics-cookies': ['analytics_storage'],
  'marketing-cookies': ['personalization_storage', 'ad_personalization', 'ad_storage', 'security_storage'],
  'functional-cookies': ['functionality_storage']
}

export function setConsentCookie (cookie, isAccepted) {
  updateConsent(cookie, isAccepted === 'yes')
  setCookie(cookie, isAccepted, 1000)
}

export function updateConsent (cookie, isAccepted) {
  updateConsentMode(cookie, isAccepted)
}

/**
 * Send consent updates based on a cookie type and a mapping between cookie types and consent types
 *
 * @param mapping Curried argument: maps between site specific cookies and consent types
 * @param cookie Site specific cookie that triggers an update to consent
 * @param isAccepted Whether the site specific cookie is accepted or not
 */
export function updateConsentMode (cookie, isAccepted) {
  var modes = cookieToModeMapping[cookie]
  modes.forEach(mode => pushConsent(mode, isAccepted ? 'granted' : 'denied'))
}

function gtag (..._) {
  var dataLayer = (window).dataLayer
  if (dataLayer) {
    dataLayer.push(arguments)
  } else {
    console.log('DataLayer not found, failed to push event', arguments)
  }
}

function pushConsent (cType, cChoice) {
  var selection = { [cType]: cChoice }
  gtag('consent', 'update', selection)
}
